var Component = require("!../../_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./vue2-countdown.vue"),
  /* template */
  require("!!../../_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5dc67b97\"}!../../_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./vue2-countdown.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue2-countdown@1.0.8@vue2-countdown/lib/vue2-countdown.vue
// module id = 1075
// module chunks = 41